import {
    INVALIDATE_PAGES,
    ERROR_PAGES,
    RECEIVE_PAGES,
    REQUEST_PAGES,
    RESET_PAGES,
    ERROR_PAGE,
    RECEIVE_PAGE,
    REQUEST_PAGE,
    UPDATE_PAGE,
    REQUEST_UPDATE_PAGE,
    SUCCESS_UPDATE_PAGE,
    ERROR_UPDATE_PAGE,
    RESET_UPDATE_PAGE,
    REQUEST_UPDATE_PAGES,
    SUCCESS_UPDATE_PAGES,
    ERROR_UPDATE_PAGES,
    RESET_UPDATE_PAGES,
    CREATE_PAGE,
    ERROR_CREATE_PAGE,
    REQUEST_CREATE_PAGE,
    RESET_CREATE_PAGE,
    SUCCESS_CREATE_PAGE,
    REQUEST_CREATE_PAGES,
    SUCCESS_CREATE_PAGES,
    ERROR_CREATE_PAGES,
    RESET_CREATE_PAGES,
    DELETE_PAGE,
    DELETE_CREATE_PAGE,
    DELETE_UPDATE_PAGE,
    REQUEST_DELETE_PAGE,
    SUCCESS_DELETE_PAGE,
    ERROR_DELETE_PAGE,
    RESET_DELETE_PAGE,
    REQUEST_PRINT_PAGE,
    SUCCESS_PRINT_PAGE,
    ERROR_PRINT_PAGE,
    RESET_PRINT_PAGE,
    RECEIVE_FILE_PAGE
} from '../actions/PageActions';

import {
    RECEIVE_ASSET,
    RECEIVE_ASSETS,
    SUCCESS_DELETE_ASSET,
    SUCCESS_CREATE_ASSET,
    SUCCESS_UPDATE_ASSET,
    SUCCESS_UPDATE_ASSETS

} from '../actions/AssetActions';
import {
    RECEIVE_SECTION,
    RECEIVE_SECTIONS,
    SUCCESS_DELETE_SECTION,
    SUCCESS_CREATE_SECTION,
    SUCCESS_UPDATE_SECTION,
    SUCCESS_UPDATE_SECTIONS

} from '../actions/SectionActions';

import {combineReducers} from 'redux';
import {LOGOUT_SUCCESS} from "../actions/AuthActions";

import merge from "lodash/merge";
import mergeWith from "lodash/mergeWith";
import union from "lodash/union";
import clone from "lodash/clone";
import difference from "lodash/difference";
import omit from "lodash/omit";
import pickBy from "lodash/pickBy";
import filter from "lodash/filter";

function getInitialStateById() {
    return {
        isFetching: false,
        didInvalidate: true,
        pages: {},
        files: {},
    }
}

function pagesById(state = getInitialStateById(), action) {
    switch (action.type) {
        case INVALIDATE_PAGES:
            return Object.assign({}, state, {
                didInvalidate: true
            });
        case REQUEST_PAGES:
            return Object.assign({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case ERROR_PAGES:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: true,
                error: action.error
            });
        case RESET_PAGES:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: true,
                error: null,
                lastUpdated: null,
                pages: {}
            });
        case RECEIVE_PAGES:
            let dato = action.pages.entities.pages;
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: false,
                pages: merge({}, state.pages, dato),
                lastUpdated: action.receivedAt
            });
        case REQUEST_PAGE:
            return Object.assign({}, state, {
                isFetching: true,
            });
        case ERROR_PAGE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });
        case RECEIVE_PAGE:
            let datoPage = action.page.entities.pages;
            return Object.assign({}, state, {
                pages: merge({}, state.pages, datoPage),
                isFetching: false,
            });
        case RECEIVE_FILE_PAGE:
            return Object.assign({}, state, {
                files: merge({}, state.files, action.file),
            });
        
        case SUCCESS_DELETE_PAGE:
            let datoPageEliminado = action.page.entities.pages;
            return Object.assign({}, state, {
                pages: mergeWith(clone(datoPageEliminado), state.pages, (objValue, srcValue) => {return objValue;})
            });
        case SUCCESS_CREATE_PAGE:
            let datoPageCreado = action.page.entities.pages;
            return Object.assign({}, state, {
                pages: mergeWith(clone(datoPageCreado), state.pages, (objValue, srcValue) => {return objValue;})
            });
        case SUCCESS_CREATE_PAGES:
            let datosPageCreado = action.pages.entities.pages;
                return Object.assign({}, state, {
                    pages: mergeWith(clone(datosPageCreado), state.pages, (objValue, srcValue) => {return objValue;})
                });
        case SUCCESS_UPDATE_PAGE:
            let datoPageActualizado = action.page.entities.pages;
            return Object.assign({}, state, {
                pages: mergeWith(clone(datoPageActualizado), state.pages, (objValue, srcValue) => {return objValue;})
            });
         case SUCCESS_UPDATE_PAGES:
            let datosPageActualizado = action.pages.entities.pages;
                return Object.assign({}, state, {
                    pages: mergeWith(clone(datosPageActualizado), state.pages, (objValue, srcValue) => {return objValue;})
                });

            //ASSET
case RECEIVE_ASSET:
    let asset = action.asset.entities && action.asset.entities.pages ? action.asset.entities.pages : {};
    return Object.assign({}, state, {
        pages: merge({}, state.pages, asset),
    });
case RECEIVE_ASSETS:
    let assets = action.assets.entities && action.assets.entities.pages ? action.assets.entities.pages : {};
    return Object.assign({}, state, {
        pages: merge({}, state.pages, assets),
    });
case SUCCESS_DELETE_ASSET:
    let datoassetEliminado = action.asset.entities && action.asset.entities.pages ? action.asset.entities.pages : {};
    return Object.assign({}, state, {
        pages: mergeWith(clone(datoassetEliminado), pickBy(state.pages, function(page) {return page.id.toString().indexOf("-") === -1 }), (objValue, srcValue) => {return objValue;})
    });
case SUCCESS_CREATE_ASSET:
    let datoassetCreado = action.asset.entities && action.asset.entities.pages ? action.asset.entities.pages : {};
    return Object.assign({}, state, {
        pages: mergeWith(clone(datoassetCreado), pickBy(state.pages, function(page) {return page.id.toString().indexOf("-") === -1 }), (objValue, srcValue) => {return objValue;})
    });
case SUCCESS_UPDATE_ASSET:
    let datoassetActualizado = action.asset.entities && action.asset.entities.pages ? action.asset.entities.pages : {};
    return Object.assign({}, state, {
        pages: mergeWith(clone(datoassetActualizado), pickBy(state.pages, function(page) {return page.id.toString().indexOf("-") === -1 }), (objValue, srcValue) => {return objValue;})
    });
 case SUCCESS_UPDATE_ASSETS:
    let datosassetActualizado = action.assets.entities && action.assets.entities.pages ? action.assets.entities.pages : {} ;
        return Object.assign({}, state, {
            pages: mergeWith(clone(datosassetActualizado), state.pages, (objValue, srcValue) => {return objValue;})
        });
//SECTION
case RECEIVE_SECTION:
    let section = action.section.entities && action.section.entities.pages ? action.section.entities.pages : {};
    return Object.assign({}, state, {
        pages: merge({}, state.pages, section),
    });
case RECEIVE_SECTIONS:
    let sections = action.sections.entities && action.sections.entities.pages ? action.sections.entities.pages : {};
    return Object.assign({}, state, {
        pages: merge({}, state.pages, sections),
    });
case SUCCESS_DELETE_SECTION:
    let datosectionEliminado = action.section.entities && action.section.entities.pages ? action.section.entities.pages : {};
    return Object.assign({}, state, {
        pages: mergeWith(clone(datosectionEliminado), pickBy(state.pages, function(page) {return page.id.toString().indexOf("-") === -1 }), (objValue, srcValue) => {return objValue;})
    });
case SUCCESS_CREATE_SECTION:
    let datosectionCreado = action.section.entities && action.section.entities.pages ? action.section.entities.pages : {};
    return Object.assign({}, state, {
        pages: mergeWith(clone(datosectionCreado), pickBy(state.pages, function(page) {return page.id.toString().indexOf("-") === -1 }), (objValue, srcValue) => {return objValue;})
    });
case SUCCESS_UPDATE_SECTION:
    let datosectionActualizado = action.section.entities && action.section.entities.pages ? action.section.entities.pages : {};
    return Object.assign({}, state, {
        pages: mergeWith(clone(datosectionActualizado), pickBy(state.pages, function(page) {return page.id.toString().indexOf("-") === -1 }), (objValue, srcValue) => {return objValue;})
    });
 case SUCCESS_UPDATE_SECTIONS:
    let datossectionActualizado = action.sections.entities && action.sections.entities.pages ? action.sections.entities.pages : {} ;
        return Object.assign({}, state, {
            pages: mergeWith(clone(datossectionActualizado), state.pages, (objValue, srcValue) => {return objValue;})
        });


            

        case LOGOUT_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: true,
                error: null,
                pages: {}
            });
        default:
            return state
    }
}


function allPages(state = [], action) {
    switch (action.type) {
        case RECEIVE_PAGES:
            return action.pages.result && action.pages.result.pages ? union(action.pages.result.pages, state) : (action.pages.result ? action.pages.result : state) ;
        case RECEIVE_PAGE:
                return action.page.result ? union([action.page.result], state) : state;
        
        case SUCCESS_CREATE_PAGE:
                   let datoPageSCreate = action.page.entities.pages;
                   let idNuevoSCreate = null;
                   if (Object.values(datoPageSCreate).length > 0)
                       idNuevoSCreate = Object.values(datoPageSCreate)[0] && Object.values(datoPageSCreate)[0].id ? Object.values(datoPageSCreate)[0].id : null;
                   if (idNuevoSCreate)
                       return union(state, [idNuevoSCreate]);
                   else
                       return state;
       case SUCCESS_CREATE_PAGES:
                   let pagesCreate = action.pages.entities && action.pages.entities.pages ? action.pages.entities.pages : null;
                   return pagesCreate ?
                       union(state, Object.values(pagesCreate).map((pages) => {
                           return pages.id
                       })) : state;
        case RESET_PAGES:
            return [];

            case RECEIVE_ASSET:
    let asset = action.asset.entities && action.asset.entities.pages ? action.asset.entities.pages : null ;
    return asset ?
        union(state, Object.values(asset).map((asset) => {
            return asset.id
        })) : state;
case RECEIVE_ASSETS:
    let assets = action.assets.entities && action.assets.entities.pages ? action.assets.entities.pages : null;
    return assets ?
        union(state, Object.values(assets).map((assets) => {
            return assets.id
        })) : state;

case SUCCESS_DELETE_ASSET:
    let assetDelete = action.asset.entities && action.asset.entities.pages ? action.asset.entities.pages : null ;
        return assetDelete ?
            union(filter(state, function(o) { return o.toString().indexOf("-") === -1; }), Object.values(assetDelete).map((asset) => {
                return asset.id
            })) : state;
case SUCCESS_CREATE_ASSET:
   let assetCreate = action.asset.entities && action.asset.entities.pages ? action.asset.entities.pages : null ;
       return assetCreate ?
          union(filter(state, function(o) { return o.toString().indexOf("-") === -1; }), Object.values(assetCreate).map((asset) => {
               return asset.id
           })) : state;
case SUCCESS_UPDATE_ASSET:
    let assetUpdate = action.asset.entities && action.asset.entities.pages ? action.asset.entities.pages : null ;
        return assetUpdate ?
            union(filter(state, function(o) { return o.toString().indexOf("-") === -1; }), Object.values(assetUpdate).map((asset) => {
                return asset.id
            })) : state;
 case SUCCESS_UPDATE_ASSETS:
     let assetsUpdate = action.assets.entities && action.assets.entities.pages ? action.assets.entities.pages : null;
        return assetsUpdate ?
            union(state, Object.values(assetsUpdate).map((assets) => {
                return assets.id
            })) : state;case RECEIVE_SECTION:
    let section = action.section.entities && action.section.entities.pages ? action.section.entities.pages : null ;
    return section ?
        union(state, Object.values(section).map((section) => {
            return section.id
        })) : state;
case RECEIVE_SECTIONS:
    let sections = action.sections.entities && action.sections.entities.pages ? action.sections.entities.pages : null;
    return sections ?
        union(state, Object.values(sections).map((sections) => {
            return sections.id
        })) : state;

case SUCCESS_DELETE_SECTION:
    let sectionDelete = action.section.entities && action.section.entities.pages ? action.section.entities.pages : null ;
        return sectionDelete ?
            union(filter(state, function(o) { return o.toString().indexOf("-") === -1; }), Object.values(sectionDelete).map((section) => {
                return section.id
            })) : state;
case SUCCESS_CREATE_SECTION:
   let sectionCreate = action.section.entities && action.section.entities.pages ? action.section.entities.pages : null ;
       return sectionCreate ?
          union(filter(state, function(o) { return o.toString().indexOf("-") === -1; }), Object.values(sectionCreate).map((section) => {
               return section.id
           })) : state;
case SUCCESS_UPDATE_SECTION:
    let sectionUpdate = action.section.entities && action.section.entities.pages ? action.section.entities.pages : null ;
        return sectionUpdate ?
            union(filter(state, function(o) { return o.toString().indexOf("-") === -1; }), Object.values(sectionUpdate).map((section) => {
                return section.id
            })) : state;
 case SUCCESS_UPDATE_SECTIONS:
     let sectionsUpdate = action.sections.entities && action.sections.entities.pages ? action.sections.entities.pages : null;
        return sectionsUpdate ?
            union(state, Object.values(sectionsUpdate).map((sections) => {
                return sections.id
            })) : state;

        case LOGOUT_SUCCESS:
            return [];
        default:
            return state
    }
}

function totalPages(state = null, action) {
    switch (action.type) {
        case RECEIVE_PAGES:
            return action.pages && action.pages.result.total ? action.pages.result.total : 0;
        case RESET_PAGES:
            return null;
        case LOGOUT_SUCCESS:
            return null;
        default:
            return state
    }
}

function update(state = {
    isUpdating: false,
    activo: {},
    activos: []
}, action) {
    switch (action.type) {
        case RECEIVE_PAGE:
            let dato = action.page.entities.pages;
            let page = dato && Object.keys(dato).length > 0 ? dato[Object.keys(dato)[0]] : {};
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: false,
                activo: page ? page : [],
                lastUpdated: action.receivedAt
            });
        case UPDATE_PAGE:
            let idsUpdate = [];
            Object.values(action.page).map((pageUpdate) => {
                if (pageUpdate && pageUpdate.id)
                    idsUpdate.push(pageUpdate.id);
            });
            return merge({}, state, {
                activo: action.page,
                activos: idsUpdate.length > 0 ? union(state.activos, idsUpdate) : state.activos,
                error: ""
            });
        case REQUEST_UPDATE_PAGE:
            return Object.assign({}, state, {
                isUpdating: true,
                error: null
            });
        case SUCCESS_UPDATE_PAGE:
            let datoPageActualizado = {};
            if (Object.values(action.page.entities.pages).length > 0)
                datoPageActualizado = Object.values(action.page.entities.pages)[0];
            return Object.assign({}, state, {
                isUpdating: false,
                lastUpdated: action.receivedAt,
                error: null,
                activo: datoPageActualizado
            });
        case ERROR_UPDATE_PAGE:
            return Object.assign({}, state, {
                isUpdating: false,
                error: action.error
            });
            case REQUEST_UPDATE_PAGES:
                return Object.assign({}, state, {
                    isUpdating: true,
                    error: null
                });
            case SUCCESS_UPDATE_PAGES:
                return Object.assign({}, state, {
                    isUpdating: false,
                    lastUpdated: action.receivedAt,
                    error: null,
                    activo: {},
                    activos: []
                });
            case ERROR_UPDATE_PAGES:
                return Object.assign({}, state, {
                    isUpdating: false,
                    error: action.error
                });
        case RESET_UPDATE_PAGE:
            return Object.assign({}, state, {
                isUpdating: false,
                activo: {},
                activos: [],
                error: ""
            });

           

           //ASSET
//TODO ver si esta bien
 case SUCCESS_CREATE_ASSET:
        return Object.assign({}, state, {
            activo: state.activo,
            activos: state.activos
        });
 case SUCCESS_UPDATE_ASSET:
        return Object.assign({}, state, {
            activo: state.activo,
            activos: state.activos
        });
 case SUCCESS_DELETE_ASSET:
        return Object.assign({}, state, {
            activo: state.activo,
            activos: state.activos
        });
 case SUCCESS_UPDATE_ASSETS:
        return Object.assign({}, state, {
            activo: state.activo,
            activos: state.activos
        });//SECTION
//TODO ver si esta bien
 case SUCCESS_CREATE_SECTION:
        return Object.assign({}, state, {
            activo: state.activo,
            activos: state.activos
        });
 case SUCCESS_UPDATE_SECTION:
        return Object.assign({}, state, {
            activo: state.activo,
            activos: state.activos
        });
 case SUCCESS_DELETE_SECTION:
        return Object.assign({}, state, {
            activo: state.activo,
            activos: state.activos
        });
 case SUCCESS_UPDATE_SECTIONS:
        return Object.assign({}, state, {
            activo: state.activo,
            activos: state.activos
        });

        case DELETE_PAGE:
            let datoPageDelete = action.page;
            let idsDelete = [];
           Object.values(action.page).map((pageDelete) => {
               if (pageDelete && pageDelete.id)
                   idsDelete.push(pageDelete.id);
           });
            if (idsDelete.length > 0)
                return Object.assign({}, state, {
                    activo: omit(clone(state.activo), Object.keys(datoPageDelete)),
                    activos: difference(clone(state.activos), idsDelete)
                });
            else
               return state;
           case DELETE_UPDATE_PAGE:
                       let datoPageDeleteUpdate = action.page;
                       let idsDeleteUpdate = [];
                      Object.values(action.page).map((pageDelete) => {
                          if (pageDelete && pageDelete.id)
                              idsDeleteUpdate.push(pageDelete.id);
                      });
                       if (idsDeleteUpdate.length > 0)
                           return Object.assign({}, state, {
                               activo: omit(clone(state.activo), Object.keys(datoPageDeleteUpdate)),
                               activos: difference(clone(state.activos), idsDeleteUpdate)
                           });
                       else
                          return state;
        case SUCCESS_DELETE_PAGE:
                    let datoPageDeleted = {};
                    if (Object.values(action.page.entities.pages).length > 0)
                        datoPageDeleted = Object.values(action.page.entities.pages)[0];
                    return Object.assign({}, state, {
                        isUpdating: false,
                        lastUpdated: action.receivedAt,
                        error: null,
                        activo: datoPageDeleted
                    });
        case LOGOUT_SUCCESS:
            return Object.assign({}, state, {
                isUpdating: false,
                activo: {},
                error: ""
            });
        default:
            return state
    }
}

function create(state = {
    isCreating: false,
    nuevo: {},
    nuevos: [],
    error: ""
}, action) {
    switch (action.type) {
        case CREATE_PAGE:
             let idsCreate = [];
             Object.values(action.page).map((pageCreate) => {
                 if (pageCreate && pageCreate.id)
                     idsCreate.push(pageCreate.id);
             });
            return merge({}, state, {
                isCreating: false,
                nuevo: action.page,
                nuevos: idsCreate.length > 0 ? union(state.nuevos, idsCreate) : state.nuevos,
                error: null,
            });
        case REQUEST_CREATE_PAGE:
            return Object.assign({}, state, {
                isCreating: true,
                error: null,
            });
        case SUCCESS_CREATE_PAGE:
            let datoPageNuevo = {};
            if (Object.values(action.page.entities.pages).length > 0)
                datoPageNuevo = Object.values(action.page.entities.pages)[0];
            return Object.assign({}, state, {
                isCreating: false,
                lastUpdated: action.receivedAt,
                error: null,
                nuevo: datoPageNuevo,
                nuevos: []
            });
        case ERROR_CREATE_PAGE:
            return Object.assign({}, state, {
                isCreating: false,
                error: action.error
            });
        case REQUEST_CREATE_PAGES:
            return Object.assign({}, state, {
                isCreating: true,
                error: null
            });
        case SUCCESS_CREATE_PAGES:
            return Object.assign({}, state, {
                isCreating: false,
                lastUpdated: action.receivedAt,
                error: null,
                nuevo: {},
                nuevos: []
            });
        case ERROR_CREATE_PAGES:
            return Object.assign({}, state, {
                isCreating: false,
                error: action.error
            });
        case RESET_CREATE_PAGE:
            return Object.assign({}, state, {
                isCreating: false,
                error: null,
                nuevo: {},
                nuevos: []
            });

             

             //ASSET
 case SUCCESS_CREATE_ASSET:
        return Object.assign({}, state, {
            nuevo: {},
            nuevos: []
        });
 case SUCCESS_UPDATE_ASSET:
        return Object.assign({}, state, {
            nuevo: {},
            nuevos: []
        });
 case SUCCESS_DELETE_ASSET:
        return Object.assign({}, state, {
            nuevo: {},
            nuevos: []
        });
 case SUCCESS_UPDATE_ASSETS:
        return Object.assign({}, state, {
            nuevo: {},
            nuevos: []
        });
//SECTION
 case SUCCESS_CREATE_SECTION:
        return Object.assign({}, state, {
            nuevo: {},
            nuevos: []
        });
 case SUCCESS_UPDATE_SECTION:
        return Object.assign({}, state, {
            nuevo: {},
            nuevos: []
        });
 case SUCCESS_DELETE_SECTION:
        return Object.assign({}, state, {
            nuevo: {},
            nuevos: []
        });
 case SUCCESS_UPDATE_SECTIONS:
        return Object.assign({}, state, {
            nuevo: {},
            nuevos: []
        });

        case DELETE_PAGE:
           let datoPageDelete = action.page;
           let idsDelete = [];
           Object.values(action.page).map((pageDelete) => {
               if (pageDelete && pageDelete.id)
                   idsDelete.push(pageDelete.id);
           });
            if (idsDelete.length > 0)
                return Object.assign({}, state, {
                    nuevo: omit(clone(state.nuevo), Object.keys(datoPageDelete)),
                    nuevos: difference(clone(state.nuevos), idsDelete)
                });
            else
               return state;
       case DELETE_CREATE_PAGE:
                  let datoPageDeleteCreate = action.page;
                  let idsDeleteCreate = [];
                  Object.values(action.page).map((pageDelete) => {
                      if (pageDelete && pageDelete.id)
                          idsDeleteCreate.push(pageDelete.id);
                  });
                   if (idsDeleteCreate.length > 0)
                       return Object.assign({}, state, {
                           nuevo: omit(clone(state.nuevo), Object.keys(datoPageDeleteCreate)),
                           nuevos: difference(clone(state.nuevos), idsDeleteCreate)
                       });
                   else
                      return state;
        case LOGOUT_SUCCESS:
            return Object.assign({}, state, {
                isCreating: false,
                error: null,
                nuevo: {}
            });
        default:
            return state
    }
}

function deleter(state = {
    isDeleting: false,
    eliminado: {},
    error: ""
}, action) {
    switch (action.type) {
        case DELETE_PAGE:
            return merge({}, state, {
                isDeleting: false,
                eliminado: action.page,
                error: null,
            });
        case REQUEST_DELETE_PAGE:
            return Object.assign({}, state, {
                isDeleting: true,
                error: null,
            });
        case SUCCESS_DELETE_PAGE:
            return Object.assign({}, state, {
                isDeleting: false,
                error: null,
            });
        case ERROR_DELETE_PAGE:
            return Object.assign({}, state, {
                isDeleting: false,
                error: action.error
            });
        case RESET_DELETE_PAGE:
            return Object.assign({}, state, {
                isDeleting: false,
                error: null,
                eliminado: {}
            });
             //ASSET
 case SUCCESS_CREATE_ASSET:
        return Object.assign({}, state, {
            eliminado: {},
        });
 case SUCCESS_UPDATE_ASSET:
        return Object.assign({}, state, {
            eliminado: {},
        });
 case SUCCESS_DELETE_ASSET:
        return Object.assign({}, state, {
            eliminado: {},
        });
 case SUCCESS_UPDATE_ASSETS:
        return Object.assign({}, state, {
            eliminado: {},
        });//SECTION
 case SUCCESS_CREATE_SECTION:
        return Object.assign({}, state, {
            eliminado: {},
        });
 case SUCCESS_UPDATE_SECTION:
        return Object.assign({}, state, {
            eliminado: {},
        });
 case SUCCESS_DELETE_SECTION:
        return Object.assign({}, state, {
            eliminado: {},
        });
 case SUCCESS_UPDATE_SECTIONS:
        return Object.assign({}, state, {
            eliminado: {},
        });
        case LOGOUT_SUCCESS:
            return Object.assign({}, state, {
                isDeleting: false,
                error: null,
                eliminado: {}
            });
        default:
            return state
    }
}

function print(state = {
    isPrinting: false,
    error: ""
}, action) {
    switch (action.type) {
        case REQUEST_PRINT_PAGE:
            return Object.assign({}, state, {
                isPrinting: true,
                error: null,
            });
        case SUCCESS_PRINT_PAGE:
            return Object.assign({}, state, {
                isPrinting: false,
                lastUpdated: action.receivedAt,
                error: null,
            });
        case ERROR_PRINT_PAGE:
            return Object.assign({}, state, {
                isPrinting: false,
                error: action.error
            });
        case LOGOUT_SUCCESS:
            return Object.assign({}, state, {
                isPrinting: false,
                error: null,
            });
        default:
            return state
    }
}

const pages = combineReducers({
    byId: pagesById,
    allIds: allPages,
    update: update,
    create: create,
    totalPages: totalPages,
    delete: deleter,
    print: print
});

export default pages;